/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectRealmSettings = (state: { realmSettings: any; }) => state.realmSettings.realmSettings;
export const selectRealmInfo = (state: { realmSettings: any }) => state.realmSettings.realmInfo;
export const selectRealmSettingsLoading = (state: { realmSettings: any }) => state.realmSettings.isLoading;
export const selectRealmSettingsError = (state: { realmSettings: any }) => state.realmSettings.error;
